import React from "react";
import { LazyRouteConfigItem } from "../../components/router/interface";

export const deviceAddSelfRouteConfig: LazyRouteConfigItem[] = [
  {
    path: "/addDevice/promptPage",
    component: React.lazy(
      () => import("../addDevice/promptPage")
    ),
  },
  {
    path: "/addDevice/bluetoothInfoSelect",
    component: React.lazy(
      () => import("../addDevice/bluetoothInfoSelect")
    ),
  },
  {
    path: "/addDevice/manualInputSN",
    component: React.lazy(
      () => import("../addDevice/manualInputSN")
    ),
  },
  {
    path: "/addDevice/wifiSelectPage",
    component: React.lazy(
      () => import("../addDevice/wifiSelectPage")
    ),
  },
  {
    path: "/addDevice/inputWifiInfo",
    component: React.lazy(
      () => import("../addDevice/inputWifiInfo")
    ),
  },
  {
    path: "/addDevice/deviceConnecting",
    component: React.lazy(
      () => import("../addDevice/deviceConnecting")
    ),
  },
  {
    path: "/addDevice/addFailedPage",
    component: React.lazy(
      () => import("../addDevice/addFailedPage")
    ),
  },
  {
    path: "/dailyReport",
    component: React.lazy(
      () => import("../dailyReport")
    ),
  },
  {
    path: "/about/feedback",
    component: React.lazy(
      () => import("../about/feedback")
    ),
  },
  {
    path: "/about/faq",
    component: React.lazy(
      () => import("../about/fap")
    ),
  },
  {
    path: "/about/story",
    component: React.lazy(
      () => import("../about/story")
    ),
  },
  {
    path: "/subscription",
    component: React.lazy(
      () => import("../subscription")
    ),
  },
  {
    path: "/about/serviceAgreement",
    component: React.lazy(
      () => import("../about/serviceAgreement")
    ),
  },
];
